
import React, { useEffect,  useState } from "react";


import { BellElectric, ImagePlay, ListCheck, ListChecks, Play } from "lucide-react"

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
const CoursePageCardSubCourse =({coursePageObject})=>{


     const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);
    
       
            const [reloadItems, setReloadItems] = useState(true);
           
               useEffect(()=>{
                   setReloadItems(false); setReloadItems(true);
                   
               },[ ])
  
                 
    return (
      <div style={{ position: "relative",boxShadow:boxShadow,
      overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
       borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                
      width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
        {!isLoaded && !hasError && (
          <div
           style={
               { 
                borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                  position: "absolute",
        top: 0,
        left: 0,
        width: `${width}%`,
        aspectRatio: aspectRatio,
        objectFit: "cover",  }}
         className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
          >
            <img
          src={loading_img}
          alt=""
        
         style={
               {
               borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
                borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
                borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
                borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                
                  position: "absolute",border:border,
        top: 0,
        left: 0,
        width: `${width}%`,padding:"10px",
      
        objectFit: "cover", aspectRatio: aspectRatio,  }}
         className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        />
          </div>
        )}
        
        <img
  
        
          src={hasError ? fallback_img : src}
          alt=""
          onLoad={() => setIsLoaded(true)}
          onError={() => setHasError(true)}
         style={
               {
                  position: "absolute",
        top: 0,
        left: 0,
        width: `${width}%`,
       
        objectFit: "cover",aspectRatio: aspectRatio  }}
         className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        />
      
      </div>
    );
  };
    return(<>
    
<div className=""

             style={{
                position:"relative",marginBottom:"20px",marginTop:"50px",overflow:"hidden",
                boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)",background:`${coursePageObject?.subCourseCard?.bgColor?.color}`,
    border:` ${coursePageObject?.subCourseCard?.border?.borderWidth?.value+coursePageObject?.subCourseCard?.border?.borderWidth?.resolution} ${coursePageObject?.subCourseCard?.border?.borderType}  ${coursePageObject?.subCourseCard?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.subCourseCard?.borderRadius?.topLeft?.value}${coursePageObject?.subCourseCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subCourseCard?.borderRadius?.topRight?.value}${coursePageObject?.subCourseCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subCourseCard?.borderRadius?.bottomLeft?.value}${coursePageObject?.subCourseCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subCourseCard?.borderRadius?.bottomRight?.value}${coursePageObject?.subCourseCard?.borderRadius?.bottomRight?.resolution}`,
}} 
          
             
            >
<div  className="subCoursePlayBtn" style={{position:"absolute",top:"90px",
                      zIndex:"9999", textAlign:"center" ,cursor:"pointer"
             ,background:`${coursePageObject?.playerButton?.bgColor?.color}`,
           border:` ${coursePageObject?.playerButton?.border?.borderWidth?.value+coursePageObject?.playerButton?.border?.borderWidth?.resolution} ${coursePageObject?.playerButton?.border?.borderType}  ${coursePageObject?.playerButton?.border?.borderColor?.color}`,
            borderTopLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.topLeft?.value}${coursePageObject?.playerButton?.borderRadius?.topLeft?.resolution}`,
                         borderTopRightRadius:`${coursePageObject?.playerButton?.borderRadius?.topRight?.value}${coursePageObject?.playerButton?.borderRadius?.topRight?.resolution}`,
                         borderBottomLeftRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.playerButton?.borderRadius?.bottomLeft?.resolution}`,
                         borderBottomRightRadius:`${coursePageObject?.playerButton?.borderRadius?.bottomRight?.value}${coursePageObject?.playerButton?.borderRadius?.bottomRight?.resolution}`,
                   
                   }}>
                     <Play strokeWidth={3}  size={35}style={{margin:"13px"}}  color={coursePageObject?.playerButton?.iconColor?.color}/>
                    </div>
       
      <ImageFallFB  boxShadow={``}
                  src={coursePageObject?.subCourseCard?.imageThumbnail?.src}
                  border={coursePageObject?.subCourseCard?.imageThumbnail?.border?.borderWidth?.value+coursePageObject?.subCourseCard?.imageThumbnail?.border?.borderWidth?.resolution+" "+coursePageObject?.subCourseCard?.imageThumbnail?.border?.borderType +" "+coursePageObject?.subCourseCard?.imageThumbnail?.border?.borderColor?.color}
                  width={ 100
                  }
                  aspectRatio={coursePageObject?.subCourseCard?.imageThumbnail?.aspectRatio?.value}
                  borderRadius={ coursePageObject?.subCourseCard?.imageThumbnail?.borderRadius
                  }/>
       
<h3 className="coursePageTitleFont" style={{padding:"5px"}}>Sub Course  1</h3>

  <div  style={{display:"flex",top:"0px",cursor:"pointer",justifyContent:"space-between" ,width:"100%"}} 
          > 
           
            <div className="" style={{padding:"5px",display:"flex",justifyContent:"flex-start",position:"relative",gap:"10px"}}> 
                       <div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCard?.iconBgColor?.color}`}}> 
                         <ListChecks strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCard?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCard?.subTextColor?.color}}> 5  Milestones</div>
                           </div><div style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCard?.iconBgColor?.color}`}}> 
                         <BellElectric strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCard?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCard?.subTextColor?.color}}> 5  Sections</div>
                           </div><div  style={{padding:"5px",display:"flex",justifyContent:"flex-start",padding:"5px",borderRadius:"10px",display:"flex",justifyContent:"flex-start",background:`${coursePageObject?.subCourseCard?.iconBgColor?.color}`}}> 
                         <ImagePlay strokeWidth={1}  size={20}    color={coursePageObject?.subCourseCard?.iconColor?.color}/>  <div className="coursePageTagsFont" style={{padding:"5px",fontSize:"12px",color:coursePageObject?.subCourseCard?.subTextColor?.color}}> 5  Chapters</div>
                           </div> 
                   </div>
           </div>

        
        <div  align="center" className="" style={{padding:"10px",background:"",marginTop:"5px", display: "flex",
        justifyContent:"space-between"}}> 
<div  className="coursePageButtonFont" style={{color:coursePageObject?.subcoursePrimaryButton?.textColor?.color,
                     padding:"10px",margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0621)"
                     ,cursor:"pointer",background:`${coursePageObject?.subcoursePrimaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.subcoursePrimaryButton?.border?.borderWidth?.value+coursePageObject?.subcoursePrimaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.subcoursePrimaryButton?.border?.borderType}  ${coursePageObject?.subcoursePrimaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.subcoursePrimaryButton?.borderRadius?.bottomRight?.resolution}`,
 }}> Show Milestones</div>
<div className="coursePageButtonFont" style={{color:coursePageObject?.subcourseSecondaryButton?.textColor?.color,padding:"10px",
                     margin:"5px",borderRadius:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.021)",cursor:"pointer",background:`${coursePageObject?.subcourseSecondaryButton?.bgColor?.color}`,
border:` ${coursePageObject?.subcourseSecondaryButton?.border?.borderWidth?.value+coursePageObject?.subcourseSecondaryButton?.border?.borderWidth?.resolution} ${coursePageObject?.subcourseSecondaryButton?.border?.borderType}  ${coursePageObject?.subcourseSecondaryButton?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${coursePageObject?.subcourseSecondaryButton?.borderRadius?.topLeft?.value}${coursePageObject?.subcourseSecondaryButton?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${coursePageObject?.subcourseSecondaryButton?.borderRadius?.topRight?.value}${coursePageObject?.subcourseSecondaryButton?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${coursePageObject?.subcourseSecondaryButton?.borderRadius?.bottomLeft?.value}${coursePageObject?.subcourseSecondaryButton?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${coursePageObject?.subcourseSecondaryButton?.borderRadius?.bottomRight?.value}${coursePageObject?.subcourseSecondaryButton?.borderRadius?.bottomRight?.resolution}`,
  }}>  Show Info </div>
</div>
</div>
    </>)
}

export default CoursePageCardSubCourse;
